import type {ReactElement} from 'react';
import styles from './facebook-footer.module.scss';

export function FacebookFooter(): ReactElement {
  return (
    <div className={styles.facebookFooter}>
      <span className={styles.facebookFooterSkeletonBar} aria-hidden="true" />
    </div>
  );
}
